// Testimonials.jsx
import React from "react";

const reviews = [
  {
    name: "Jessica M.",
    comment:
      "LawnSmartPro made my lawn look better than it ever has. Fast, friendly, and reliable!",
  },
  {
    name: "David L.",
    comment:
      "Highly recommend! The crew was professional and the results were incredible.",
  },
  {
    name: "Maria C.",
    comment:
      "The irrigation upgrade saved me money and my lawn is greener than ever.",
  },
];

const Testimonials = () => {
  return (
    <section className="bg-white py-16 px-6 text-center">
      <h2 className="text-2xl font-semibold text-green-800 mb-10">
        What Homeowners Are Saying
      </h2>
      <div className="grid gap-6 md:grid-cols-3">
        {reviews.map((r, index) => (
          <div
            key={index}
            className="bg-green-50 p-6 rounded-xl shadow-sm border text-left"
          >
            <p className="text-gray-700 italic mb-3">“{r.comment}”</p>
            <span className="text-green-700 font-semibold">— {r.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
